import { type DynamicModalStack } from '@/common/types/modal';

import { type RootState } from '../store';

const selectFullscreenModalsList = (state: RootState): DynamicModalStack =>
  state.modals.list;

export { selectFullscreenModalsList };
